if (module.hot) {
  module.hot.accept();
}

// import { initCursor } from "./cursor";
import { initNav } from "./nav";
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

let mm = gsap.matchMedia();

mm.add("(min-width: 768px)", () => {
  // create the scrollSmoother before your scrollTriggers
  ScrollSmoother.create({
    smooth: 1, // how long (in seconds) it takes to "catch up" to the native scroll position
    effects: true, // looks for data-speed and data-lag attributes on elements
    smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
  });
});

function initModal() {
  const listItems = document.querySelectorAll("#list li");
  const mapLocations = document.querySelectorAll(".ph-location");
  const modalBackdrop = document.getElementById("modalBackdrop");
  const modal = document.getElementById("modal");
  const modalTitle = document.getElementById("modalTitle");
  const modalImage = document.getElementById("modalImage");
  const modalText = document.getElementById("modalText");
  const closeButton = document.getElementById("closeButton");

  const contentData = {
    1: {
      title: "Port of Recife",
      image:
        "https://res.cloudinary.com/dv9hlh4du/image/upload/v1668282288/Website/images/port-landscape_nqlpux.jpg",
      text: [
        `Constituting a system of local and global interactions, Recife is
        another example of a city developed from its port. The capital of
        Pernambuco was named after the line of rocks formed by a natural
        coral reef. In the nineteenth century, the port of Recife received
        different types of vessels, such as ships, brigs, and sailboats. In
        1845, the Decree no. 358, of August 14 created the Captaincy of the
        Port of Recife. As a space and place of influences, the port
        catalyzed the growth and the political, commercial, and cultural
        life of Recife as a facilitator of both immigration and emigration.`,
        `Recife’s natural harbor thus turned into a transit point for
        peoples, wealth, goods, but also became, historically, a place for
        the spread of medical knowledge as a consequence of the disembarking
        of diseases.`,
      ],
    },
    2: {
      title: "Nogueira Island",
      image: "",
      text: [
        `For greater control of port movement, the Provedoria de Saúde do
        Porto suggested to the provincial government of Pernambuco that
        vessels coming from infected places should not have immediate
        communication with the land. It was then established that a health
        letter should be presented at the time of entry of every vessel and
        the ships would be subjected to observation. Passengers would have
        to go to the lazaretto (an isolation hospital) where they would be
        accommodated and have medical assistance.`,
        `As described by Manoel da Costa Honorato in 1863, the lazaretto
        existed at the Pontal do Pina beach in the Nogueira Island, “South
        from the port of Recife.” The lazaretto served to “quarantine
        travelers from foreign countries in times of plague.”`,
      ],
    },
    3: {
      title: "Public Cemetery",
      image:
        "https://res.cloudinary.com/dv9hlh4du/image/upload/v1689963790/Website/images/Cemit%C3%A9rio_P%C3%BAblico_Senhor_Bom_Jesus_da_Reden%C3%A7%C3%A3o_Conhecido_Popularmente_Cemit%C3%A9rio_de_Santo_Amaro_-_Recife_1880_-_source_Acervo_de_Iconografia_Instituto_Moreira_Salles_fikmeq.jpg",
      text: [
        `On March 1, 1851, the public cemetery Bom Jesus da Redenção was
        created, in the neighborhood of Santo Amaro das Salinas. The
        physicians of Recife justified its necessity arguing against the
        conventional burial of bodies on church grounds. After long debates,
        and under the impact of the great and successive epidemics that
        plagued the city, the local government decided for the project of a
        cemetery on land away from downtown. Engineer José Mamede Alves
        Ferreira presided the commission in charge of preparing the project.
        The government purchased a part of the land while its owner,
        Norberto Joaquim José Guedes, donated the rest.`,
      ],
    },
    4: {
      title: "Hospital dos Lázaros",
      image:
        "https://res.cloudinary.com/dv9hlh4du/image/upload/v1668285121/Website/images/hospital_lazaros_fptsv8.jpg",
      text: [
        `In 1714, Father Antônio Manoel created the first asylum for leprosy
        patients of colonial Brazil in Recife the capital of Pernambuco. In
        1789, the place became the Hospital dos Lázaros do Recife, located
        in the Santo Amaro district. The Santa Casa de Misericórdia
        maintained the institution until 1860. The hospital ended its
        activities in the early years of the 1940s.`,
      ],
    },
    5: {
      title: "Public Health Council",
      image: "",
      text: [
        `In 1845, the Health Council of Recife was created through Provincial
        Law n.143, of 21 May. Its first president was the physician Joaquim
        de Aquino Fonseca, trained in Paris. In 1853, the Provincial Law
        n.316, of May 14, extinguishes the Health Council and creates the
        Public Hygiene Commission on August 11.`,
        `These institutions were responsible for: promoting and propagating
        vaccination, visiting prisons and public aid houses with some
        assiduity, inspecting industrial establishments, factories and
        workshops in the city of Recife; guard cemeteries, catacombs and
        other burial places; take care of the means to prevent epidemics,
        endemics and contagions; repress what have been called “the effects
        of quackery”; frequently examine the foods given to consumption;
        visit pharmacies and examine their drugs and medicines; give advice
        on hygiene matters; make medical statistics for the province of
        Pernambuco; and to supervise health professionals in the performance
        of their duties. Its staff consisted of doctors in Medicine, versed
        in the study of Public Hygiene and Legal Medicine, in addition to
        pharmacists experienced in chemical analysis and toxicological
        practice.`,
      ],
    },
  };

  listItems.forEach(function (item) {
    item.addEventListener("click", function () {
      var contentId = this.getAttribute("data-content");
      var content = contentData[contentId];

      if (content) {
        modalTitle.textContent = content.title;
        // Check if image url is present and if so, show image
        if (content.image) {
          modalImage.src = content.image;
          modalImage.style.display = "block";
        } else {
          modalImage.style.display = "none";
        }

        modalText.innerHTML = ""; // Clear existing content

        content.text.forEach(function (paragraph) {
          var p = document.createElement("p");
          p.textContent = paragraph;
          modalText.appendChild(p);
        });

        showModal();
      }
    });
  });

  mapLocations.forEach(function (item) {
    item.addEventListener("click", function () {
      var contentId = this.getAttribute("data-content");
      var content = contentData[contentId];

      if (content) {
        modalTitle.textContent = content.title;
        // Check if image url is present and if so, show image
        if (content.image) {
          modalImage.src = content.image;
          modalImage.style.display = "block";
        } else {
          modalImage.style.display = "none";
        }

        modalText.innerHTML = ""; // Clear existing content

        content.text.forEach(function (paragraph) {
          var p = document.createElement("p");
          p.textContent = paragraph;
          modalText.appendChild(p);
        });

        showModal();
      }
    });
  });

  modalBackdrop.addEventListener("click", function () {
    hideModal();
  });

  closeButton.addEventListener("click", function () {
    hideModal();
  });

  function showModal() {
    document.body.classList.add("modal-open");
    modalBackdrop.style.display = "block";
    modal.style.display = "block";
    gsap.to(modalBackdrop, { duration: 0.3, autoAlpha: 1 });
    gsap.to(modal, { duration: 0.3, right: "0%", ease: "Power1.easeOut" });
  }

  function hideModal() {
    document.body.classList.remove("modal-open");
    gsap.to(modalBackdrop, { duration: 0.3, autoAlpha: 0 });
    gsap.to(modal, {
      duration: 0.3,
      right: "-120%",
      ease: "Power1.easeOut",
      onComplete: hideModalComplete,
    });
  }

  function hideModalComplete() {
    modalBackdrop.style.display = "none";
  }
}

function init() {
  // initCursor();
  initNav();
  initModal();
  // initSlideInfo();
}

window.addEventListener("load", function () {
  init();
});
